import React from 'react';
// import PropTypes from 'prop-types';
import UserProfileContent from './UserProfileContent';
import { connect } from 'dva';
import SidebarDetailHeader from '../SidebarDetailHeader';

function UserContentSidebar(props) {
  
  return (
    <>
      <SidebarDetailHeader
        title="Account"
      />
      <UserProfileContent />
    </>
  );
}

UserContentSidebar.propTypes = {

};

export default connect(() => {
  return {};
})(UserContentSidebar);